/**
 * @fileoverview Componente responsável por estruturar o layout avançado da tela de tickets.
 */

import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)(({ theme }) => ({
    height: `calc(100% - 48px)`,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
        height: "100%",
    },
}));

export default TicketAdvancedLayout;